'use strict';

const Event = require('./../lib/events');
const Breakpoint = require('./../lib/breakpoints');

class Menu {

    constructor() {

        if (Breakpoint.getCurrentWindowWidth() < Breakpoint.get('medium')) {

            Event.on('click', '.show-more', (event) => {
                event.preventDefault();

                let link = event.currentTarget;
                link.classList.toggle('selected');

            });

        }

        // Toggles aria-expanded
        const menuButton = document.querySelector('#menu-button');

        menuButton.addEventListener('click', () => {
            menuButton.setAttribute('aria-expanded', menuButton.getAttribute('aria-expanded') === 'false' ? 'true' : 'false')
        })

    }

}

module.exports = Menu;
